module.exports = __webpack_public_path__ + "static/media/Storage.674524c6.svg";